import CardHeading from '@commons/headings/card'
import ScrollView from '@commons/scroll'
import AppointmentRequestCard from '@commons/cards/appointmentRequest'
import AppointmentRequestCardLoader from '@commons/cards/appointmentRequest/loader'
import Empty from '@commons/empty'
import { styleCardItem } from './style'
import { useSelector } from 'react-redux'
import { Appointment } from '@apis'
import { useEffect, Fragment } from 'react'
import Alert from '@commons/popups/alert'
import useAppointmentActions from '@hooks/useAppointmentActions'
import AppointmentReschedule from '@commons/popups/reschedule'
const AppointmentRequests = () => {
  const { items: appointments, loading } = useSelector(
    (state: any) => state.homeConsultAppointments,
  )
  const {
    alertInfo,
    visible,
    loading: alertLoading,
    handleClickBtn,
    handleClickYes,
    handleClose,
  } = useAppointmentActions({
    selector: 'homeConsultAppointments',
  })
  const fetchData = async () => {
    await Appointment.list({
      params: {
        page: 1,
        limit: 12,
        type: 'Consult',
        status: 'Pending',
        isSchedule: true,
      },
      state: 'homeConsultAppointments',
      action: 'set',
    })

      .catch(() => {})
  }
  useEffect(() => {
    if (!appointments?.length) {
      fetchData()
    }
  }, [])
  return (
    <>
      <CardHeading
        tc="primary"
        hasView
        title="Appointment Requests"
        path="/doctor/appointments/requests?tab=bookings"
      />
      <ScrollView onClick={handleClickBtn}>
        {!!loading ? (
          <>
            {Array(6)
              .fill(0)
              ?.map((_: any, index: any) => {
                return (
                  <Fragment key={index}>
                    <AppointmentRequestCardLoader styleCard={styleCardItem} />
                  </Fragment>
                )
              })}
          </>
        ) : (
          <>
            {!!appointments?.length ? (
              <>
                {appointments?.map((appointment: any) => {
                  return (
                    <Fragment key={appointment?.id}>
                      <AppointmentRequestCard
                        appointment={appointment}
                        styleCard={styleCardItem}
                      />
                    </Fragment>
                  )
                })}
              </>
            ) : (
              <Empty />
            )}
          </>
        )}
      </ScrollView>
      {!!visible && alertInfo?.type == 'confirm' && (
        <Alert
          title={'Confirmed Request'}
          visible={visible}
          description="Are you sure you want to confirmed request ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}

      {!!visible && alertInfo?.type == 'reschedule' && (
        <AppointmentReschedule
          visible={visible}
          id={alertInfo?.id}
          onClose={handleClose}
          appointment={appointments?.find(
            (appointment: any) => appointment?.id == alertInfo?.id,
          )}
          selector={'homeConsultAppointments'}
        />
      )}
    </>
  )
}

export default AppointmentRequests
